import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.address.organisationName != null && _ctx.address.organisationName.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.address.organisationName), 1))
      : _createCommentVNode("", true),
    (this.personal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(this.personalString), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, _toDisplayString(_ctx.address.postalAddress), 1),
    _createElementVNode("div", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.address.postalCode), 1),
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_ctx.address.localityName), 1)
    ]),
    (this.outputCountry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.address.country), 1))
      : _createCommentVNode("", true)
  ], 64))
}